module.exports = "<div class=\"section-wrapper\">\n\n    <div class=\"row\">\n        <div class=\"col text-center\">\n            <a href=\"https://www.adcolombia.org/\" target=\"_blank\">\n                <img src=\"assets/logo.svg\" class=\"pt-5 pb-5\" alt=\"Asambleas de Dios\" class=\"click-able\">\n            </a>\n        </div>\n    </div>\n\n    <app-member-page [member]=\"member\"></app-member-page>\n\n    <app-solicitar-personeria-juridica *ngIf=\"member.is_academic\"></app-solicitar-personeria-juridica>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/pages/home/home.component.html
// module id = ./src/app/admin/pages/home/home.component.html
// module chunks = main